import { render, staticRenderFns } from "./LoanView.vue?vue&type=template&id=6a98fc16&scoped=true&lang=pug&"
import script from "./LoanView.vue?vue&type=script&lang=js&"
export * from "./LoanView.vue?vue&type=script&lang=js&"
import style0 from "./LoanView.vue?vue&type=style&index=0&id=6a98fc16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a98fc16",
  null
  
)

/* custom blocks */
import block0 from "./LoanView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports